export function randomBetween(min: number, max: number): number {
  return Math.round(min + Math.random() * (max - min));
}

export function wait(ms: number): Promise<void> {
  return new Promise((resolve) => window.setTimeout(resolve, ms));
}

export function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/g, (char) => {
    const map: Record<string, string> = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;"
    };
    return map[char] ?? char;
  });
}

/**
 * Printed asset captions open with their own identifier ("FIGURE 5.6(A) ..."),
 * so joining them to the record's displayed identifier prints it twice. Strips
 * that leading repetition for display only — stored captions are untouched.
 */
export function captionWithoutIdentifier(
  number: string | null | undefined,
  caption: string | null | undefined
): string {
  const trimmedCaption = caption?.trim() || "";
  const trimmedNumber = number?.trim() || "";
  if (!trimmedCaption || !trimmedNumber) return trimmedCaption;

  const identifierPattern = trimmedNumber
    .split(/\s+/)
    .map((part) => part.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
    .join("\\s+");
  const repeatedIdentifier = new RegExp(
    `^(?:\\*\\s*)?${identifierPattern}(?=\\s|$)\\s*(?:[-–—:]\\s*)?`,
    "i"
  );

  return trimmedCaption.replace(repeatedIdentifier, "").trim();
}

export function initialsFor(username: string): string {
  const parts = username.trim().split(/[\s._-]+/).filter(Boolean);
  const initials = parts.length > 1
    ? `${parts[0][0] || ""}${parts[1][0] || ""}`
    : username.slice(0, 2);
  return initials.toUpperCase() || "AJ";
}

